<template>
	<div class="chat-box" @click="onClickChatBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="50px">
				<span class="chat-title">{{ title }}</span>
				<div class="header-actions">
					<span title="搜索聊天记录" class="btn-side el-icon-search" @click="searchVisible=!searchVisible"></span>
					<span title="买家情况" v-show="isGateChat" class="btn-side btn-side-buyer el-icon-user"
						:class="{'btn-side-active': showBuyerSide}" @click="toggleBuyerSide()"></span>
					<span title="订单" v-show="isGroup && orderCtx && orderCtx.bound" class="btn-side btn-side-order el-icon-tickets" @click="toggleOrderSide()"></span>
					<span title="群聊信息" v-show="isGroup" class="btn-side el-icon-more" @click="toggleGroupSide()"></span>
				</div>
			</el-header>
			<el-main style="padding: 0;">
				<chat-search-panel :visible="searchVisible" :is-group="isGroup"
					:chat-info="isGroup ? group : conversation"
					:members="groupMembers"
					@close="searchVisible=false"
					@locate="onLocateSearchResult" />
				<el-container>
					<el-container class="content-box">
						<div class="pin-bar" v-if="pinnedList.length" :class="{ 'pin-bar-expanded': pinExpanded }">
							<span class="pin-bar-label">置顶</span>
							<div class="pin-list" :class="pinExpanded ? 'pin-list-expanded' : 'pin-list-collapsed'">
								<div class="pin-item" v-for="p in visiblePins" :key="p.id" @click="onLocatePin(p)">
									<span class="pin-sender">{{ p.sendNickName }}</span>
									<span v-if="pinIsImage(p) || pinIsVideo(p)" class="pin-media"
										@click.stop="onOpenPinMedia(p)">
										<img v-if="pinThumb(p)" class="pin-thumb" :src="pinThumb(p)" draggable="false" @dragstart.prevent />
										<span v-else class="pin-thumb pin-thumb-empty">{{ pinIsVideo(p) ? '视频' : '图片' }}</span>
										<i v-if="pinIsVideo(p)" class="pin-play el-icon-video-play"></i>
									</span>
									<span v-else class="pin-content"><span class="pin-content-text">{{ pinPreview(p) }}</span></span>
									<span class="pin-remove el-icon-close" title="取消置顶"
										@click.stop="onUnpin(p)"></span>
								</div>
							</div>
							<span v-if="pinnedList.length > 3" class="pin-toggle"
								:class="pinExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
								:title="pinExpanded ? '收起' : '展开全部'" @click.stop="pinExpanded = !pinExpanded"></span>
						</div>
						<el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
							<div class="im-chat-box">
								<div v-for="m in messages" :key="m.localId">
									<chat-message-item :id="m.localId" :active="activeMessageLocalId == m.localId"
										@call="onCall(m.type)" :mine="m.sendId == mine.id" :headImage="headImage(m)"
										:showName="showName(m)" :group="group" :conversation="conversation" :message="m"
										:groupMemberMap="groupMemberMap" :selectMode="selectMode"
									:selected="selectedLocalIds.includes(m.localId)"
									:favorited="favoriteIds.includes(m.id)"
									@resend="onResendMessage"
									@copy="onCopyMessage" @delete="deleteMessage" @recall="recallMessage"
									@quote="onQuote" @edit="onEdit" @pin="onPin" @favorite="onFavorite"
									@locate="onLocateQuote"
										@forward="onForward" @multiselect="enterSelectMode"
										@toggleselect="onToggleSelect" @openmerge="onOpenMerge">
									</chat-message-item>
								</div>
							</div>
						</el-main>
						<div v-if="conversation.atMe || conversation.atAll" class="locate-tip"
							@click="scrollToAtMessage">
							有人@我 </div>
						<div v-else-if="!chatStore.isInBottom" class="locate-tip" @click="onScrollToBottom">
							{{ chatStore.newMessageSize > 0 ? chatStore.newMessageSize + '条新消息' : '回到底部' }}
						</div>
						<!-- 财务分配看板: 仅财务在上粉群(绑定商户群)内可见,贴聊天区右上角(isGroup 双保险,私聊绝不展示) -->
						<chat-assign-board v-if="isGroup && orderCtx && orderCtx.bound && orderCtx.isFinance"
							:orderCtx="orderCtx"></chat-assign-board>
						<el-footer v-if="selectMode" height="64px" class="im-chat-select-bar">
							<span class="sel-count">已选 {{ selectedLocalIds.length }} 条</span>
							<div class="sel-actions">
								<el-button size="small" :disabled="!selectedLocalIds.length"
									@click="onForwardSelected('each')">逐条转发</el-button>
								<el-button size="small" type="primary" :disabled="!selectedLocalIds.length"
									@click="onForwardSelected('merge')">合并转发</el-button>
								<el-button size="small" @click="exitSelectMode">取消</el-button>
							</div>
						</el-footer>
						<el-footer v-else height="220px" class="im-chat-footer">
							<!-- 快捷回复面板: 点选填充到输入框可二次编辑; 财务/管理员可增改删, 发送(点选)仅meimei -->
							<div class="gate-qr-panel" v-if="showQuickReply && (isGateChatMine || canManageQuickReply)" @click.stop>
								<div class="gate-qr-head">快捷回复<span class="gate-qr-sub">{{ isGateChatMine ? '点选填入输入框，可编辑后再发送' : '财务可管理(增/改/删)，发送仅meimei' }}</span></div>
								<div class="gate-qr-list">
									<div class="gate-qr-empty" v-if="!gateQuickReplies.length">暂无快捷回复，请在下方添加</div>
									<div class="gate-qr-item" v-for="r in gateQuickReplies" :key="r.id"
										@click="pickGateQuickReply(r)">
										<span class="gate-qr-text">{{ r.content }}</span>
										<span class="gate-qr-del el-icon-edit" title="修改" v-if="canManageQuickReply"
											@click.stop="startEditQuickReply(r)"></span>
										<span class="gate-qr-del el-icon-delete" title="删除" v-if="canManageQuickReply"
											@click.stop="deleteGateQuickReply(r)"></span>
									</div>
								</div>
								<div class="gate-qr-add" v-if="canManageQuickReply">
									<el-input v-model="quickReplyInput" size="mini" maxlength="500"
										:placeholder="editingQuickReply ? '修改快捷回复内容' : '添加新的快捷回复'"
										@keyup.enter.native="editingQuickReply ? saveGateQuickReply() : addGateQuickReply()"></el-input>
									<el-button size="mini" v-if="editingQuickReply" @click="cancelEditQuickReply()">取消</el-button>
									<el-button size="mini" type="primary"
										@click="editingQuickReply ? saveGateQuickReply() : addGateQuickReply()">{{ editingQuickReply ? '保存' : '添加' }}</el-button>
								</div>
							</div>
							<!-- 收藏面板: 点击文字填入输入框可二次编辑, 支持复制/删除 -->
							<div class="favorite-panel" v-if="showFavorite" @click.stop>
								<div class="favorite-head">我的收藏
									<span class="favorite-sub">点文字填入输入框 · 可复制/删除</span>
									<span class="favorite-close el-icon-close" title="关闭" @click="showFavorite = false"></span>
								</div>
								<div class="favorite-list" v-loading="favoriteLoading">
									<div class="favorite-empty" v-if="!favoriteLoading && !favorites.length">暂无收藏，右键消息选择“收藏”即可加入</div>
									<div class="favorite-item" v-for="f in favorites" :key="f.id">
										<div class="fav-meta">{{ f.sendNickName || '我' }} · {{ fmtFavoriteTime(f.sendTime) }}</div>
										<div class="fav-body">
											<!-- 文字: 点击填入输入框快捷发送 -->
											<div v-if="f.messageType === 0" class="fav-text" @click="pickFavorite(f)">{{ f.content }}</div>
											<!-- 图片: 缩略图点击看大图 -->
											<img v-else-if="f.messageType === 1 && favContentObj(f)" class="fav-img"
												:src="favContentObj(f).thumbUrl || favContentObj(f).originUrl" @click="pickFavorite(f)" />
											<!-- 视频: 内嵌播放 -->
											<video v-else-if="f.messageType === 4 && favContentObj(f)" class="fav-video" controls
												preload="metadata" :poster="favContentObj(f).thumbUrl">
												<source :src="favContentObj(f).url" type="video/mp4" />
											</video>
											<!-- 语音: 内嵌播放 -->
											<audio v-else-if="f.messageType === 3 && favContentObj(f)" class="fav-audio" controls
												:src="favContentObj(f).url"></audio>
											<!-- 文件: 点击打开/下载 -->
											<div v-else-if="f.messageType === 2" class="fav-file" @click="pickFavorite(f)">
												<i class="el-icon-document"></i>
												<span class="fav-file-name">{{ favFileName(f) }}</span>
											</div>
											<div v-else class="fav-text fav-plain">{{ favPreviewText(f) }}</div>
										</div>
										<div class="fav-actions">
											<el-button size="mini" v-if="f.messageType === 0" @click="pickFavorite(f)">填入输入框</el-button>
											<el-button size="mini" v-if="f.messageType === 0 || f.messageType === 1" @click="copyFavorite(f)">复制</el-button>
											<el-button size="mini" type="danger" plain @click="removeFavorite(f)">删除</el-button>
										</div>
									</div>
								</div>
							</div>
							<!-- 接待会话防重复回复: 有人正在回复该买家时黄条提醒,并拦截发送 -->
							<div class="gate-typing-bar" v-if="gateTypingUser">
								<i class="el-icon-warning"></i>
								<span>{{ gateTypingUser }} 正在回复该买家，请等待其回复完成，避免重复回复</span>
							</div>
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="发送图片">
									<file-upload :action="'/image/upload?thumbSize=300'" :maxSize="5 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="1024 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div title="发送语音" class="el-icon-microphone" :class="{'chat-tool-active': voiceMode}"
									@click="toggleVoiceMode()">
								</div>
								<!-- 收藏列表入口: 查看/快捷发送/复制已收藏的消息 -->
								<div title="我的收藏" class="el-icon-star-off" :class="{'chat-tool-active': showFavorite}"
									@click.stop="toggleFavoritePanel()">
								</div>
								<!-- 芝麻接待快捷回复: 发送入口仅指定财务(meimei); 财务/管理员可打开做管理(增/改/删) -->
								<div title="快捷回复" v-if="isGateChatMine || canManageQuickReply" class="el-icon-chat-dot-square"
									:class="{'chat-tool-active': showQuickReply}" @click.stop="toggleQuickReply()">
								</div>
								<!-- 音视频通话已下线(2026-08-02 决策: 仅保留 iOS/安卓 App 间通话), 按钮隐藏不删码 -->
								<div title="语音通话" v-if="false" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="多人通话" v-if="false" class="el-icon-video-camera"
									@click="onGroupVideo()">
								</div>
								<div v-show="isGroup && kqCtx && kqCtx.canReport" class="kq-entry" title="客情统计填报"
									@click="openKqDialog()">
									<i class="el-icon-data-analysis"></i>
									<span class="kq-entry-text">客情统计</span>
								</div>
								<!-- 收款配置入口(支付宝接单+接单微信): 仅上粉群(群名含后台配置关键词)内可见 -->
								<div v-show="isFanGroup" class="kq-entry wechat-entry" title="配置我的收款信息(支付宝/微信)"
									@click="openWechatDialog()">
									<i class="el-icon-chat-dot-round"></i>
									<span class="kq-entry-text">收款配置</span>
								</div>
								<!-- 电销记录入口(交叉电话销售): 与收款配置同位置,仅上粉群内可见 -->
								<div v-show="isFanGroup" class="kq-entry wechat-entry" title="电销池与拨打记录(接待人本人不可见)"
									@click="openTelesalesDialog()">
									<i class="el-icon-phone-outline"></i>
									<span class="kq-entry-text">电销记录</span>
								</div>
								<!-- 餐费自助入口: 仅与科长账号(NB100002, userId=4)的私聊显示 -->
								<div v-show="isMealBossChat && configStore.features.meal" class="kq-entry" title="我的用餐统计(点日历标记不吃)"
									@click="$refs.mealCalendar.open()">
									<i class="el-icon-dish"></i>
									<span class="kq-entry-text">用餐统计</span>
								</div>
								<!-- 考勤入口: 仅内部大群; 管理员/财务打开考勤看板, 业务员一键打卡 -->
								<div v-show="showAttEntry" class="kq-entry att-entry" title="考勤统计(管理员/财务)"
									@click="openAttendance()">
									<i class="el-icon-date"></i>
									<span class="kq-entry-text">考勤</span>
								</div>
								<div v-show="showPunchEntry" class="kq-entry punch-entry" :title="punchTip"
									@click="myAttDialogVisible = true">
									<i class="el-icon-alarm-clock"></i>
									<span class="kq-entry-text">{{ punchText }}</span>
								</div>
								<!-- 金十数据入口(快讯/头条/财经日历): 仅内部大群 -->
								<div v-show="isInternalGroup" class="kq-entry jin10-entry" title="金十数据(快讯/头条/财经日历)"
									@click="jin10DialogVisible = true">
									<i class="el-icon-trend-charts"></i>
									<span class="kq-entry-text">金十数据</span>
								</div>
								<!-- 一键发帖入口(员工各自绑定平台账号发帖): 仅内部大群, 金十数据右侧 -->
								<div v-show="isInternalGroup && configStore.features.social" class="kq-entry post-entry" title="一键发帖(绑定你的平台账号: 发布/看数据/回评论)"
									@click="postDialogVisible = true">
									<i class="el-icon-share"></i>
									<span class="kq-entry-text">发帖</span>
								</div>
								<div v-show="isInternalGroup && hasPhones" class="kq-entry" title="我的手机"
									@click="openMyPhones()">
									<i class="el-icon-mobile-phone"></i>
									<span class="kq-entry-text">我的手机</span>
								</div>
							</div>
							<div class="quote-tip" v-if="quoteMessage">
								<span class="quote-tip-content">引用 {{ quoteMessage.sendNickName || showName(quoteMessage) }}：{{ quotePreview }}</span>
								<span class="quote-tip-close el-icon-close" @click="cancelQuote"></span>
							</div>
							<div class="send-content-area">
								<ChatInput v-if="!voiceMode" :ownerId="group.ownerId" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" @typing="onGateTypingInput" />
								<div v-else class="voice-hold-bar">
									<div class="voice-hold-btn"
										:class="{'recording': isRecording, 'will-cancel': isRecording && recordCancelled}"
										@mousedown.prevent="onVoiceStart"
										@touchstart.prevent="onVoiceStart">{{ isRecording ? (recordCancelled ? '松开 取消' : '松开 发送') : '按住说话' }}</div>
								</div>
								<div class="send-btn-area" v-if="!voiceMode">
									<el-button type="primary" icon="el-icon-s-promotion"
										@click="notifySend()">发送</el-button>
								</div>
								<!-- 录音遮罩 -->
								<div class="voice-record-mask" v-if="isRecording">
									<div class="voice-record-box">
										<div class="voice-record-mic" :class="{'will-cancel': recordCancelled}">
											<i :class="recordCancelled ? 'el-icon-close' : 'el-icon-microphone'"></i>
										</div>
										<div class="voice-record-tip">{{ recordCancelled ? '松开手指，取消发送' : '上滑取消发送' }}</div>
										<div class="voice-record-time" v-if="!recordCancelled">{{ recordDuration }}"</div>
									</div>
								</div>
							</div>
							<div class="chat-editer-mask" v-if="notAllowInputTip">
								<span class="icon el-icon-warning"></span>
								<span>{{ notAllowInputTip }}</span>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="side-box" width="320px" v-if="showSide">
						<chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)">
						</chat-group-side>
					</el-aside>
					<el-aside class="side-box" width="320px" v-if="showOrderSide">
						<chat-group-order-side :group="group" :orderCtx="orderCtx" @close="onChildCloseOrderSide"></chat-group-order-side>
					</el-aside>
					<!-- 芝麻接待会话: 买家情况实时画像(打开时实时拉取,非下单快照) -->
					<el-aside class="side-box" width="320px" v-if="showBuyerSide && isGateChat">
						<chat-buyer-profile-side :buyer-user-id="conversation.targetId"></chat-buyer-profile-side>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector ref="rtcSel" :group="group" @complete="onInviteOk"></group-member-selector>
			<!-- 群通话加入弹窗已随音视频一起下线(2026-08-02), 组件不挂载 -->
			<!-- <rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join> -->
			<forward-dialog :dialogVisible="forwardVisible" :mode="forwardMode" :count="forwardCount"
				@confirm="doForward" @close="forwardVisible = false"></forward-dialog>
			<merge-message-viewer :dialogVisible="mergeViewerVisible" :data="mergeViewerData"
				@close="mergeViewerVisible = false"></merge-message-viewer>
			<chat-kq-report-dialog :visible="kqDialogVisible" :kqCtx="kqCtx"
				@close="kqDialogVisible = false"></chat-kq-report-dialog>
			<!-- 考勤看板弹窗(内部大群入口, 管理员/财务) -->
			<chat-attendance-dialog :visible="attDialogVisible" @close="attDialogVisible = false"
				@confirmed="loadMyAttendance()"></chat-attendance-dialog>
			<!-- 我的考勤弹窗(业务员: 打卡/请假/我的日历) -->
			<chat-my-att-dialog :visible="myAttDialogVisible" @close="myAttDialogVisible = false"
				@changed="loadMyAttendance()"></chat-my-att-dialog>
			<!-- 金十数据弹窗(快讯/头条/财经日历, 内部大群工具栏入口) -->
			<chat-jin10-dialog :visible="jin10DialogVisible" @close="jin10DialogVisible = false"></chat-jin10-dialog>
			<!-- 一键发帖弹窗(员工各自绑定平台账号: 绑定/发布/数据/评论四页签) -->
			<chat-post-dialog :visible="postDialogVisible" @close="postDialogVisible = false"></chat-post-dialog>
			<!-- 业务员收款配置弹窗(上粉群入口: 支付宝接单+接单微信) -->
			<chat-sales-wechat-dialog :visible="salesWechatDialogVisible"
				@close="salesWechatDialogVisible = false"></chat-sales-wechat-dialog>
			<!-- 电销记录弹窗(上粉群入口: 池塘管理员分配/我的电销/已成交) -->
			<telesales-dialog :visible="telesalesDialogVisible" :group-id="group.id"
				:is-manager="orderCtx && !!orderCtx.isFinance"
				@close="telesalesDialogVisible = false"></telesales-dialog>
			<!-- 我的用餐统计日历(与科长私聊时工具栏入口打开) -->
			<meal-calendar ref="mealCalendar"></meal-calendar>
			<!-- 我的手机弹窗(群聊工具栏入口) -->
			<el-dialog title="我的手机" :visible.sync="myPhoneVisible" width="620px"
				custom-class="my-phone-dialog" @open="loadMyPhones" :append-to-body="true">
				<div v-loading="myPhoneLoading" style="min-height:200px">
					<div v-if="!myPhoneLoading && myPhones.length === 0" style="text-align:center;padding:60px 0;color:#999">
						<i class="el-icon-mobile-phone" style="font-size:40px;display:block;margin-bottom:12px"></i>
						暂无手机记录
					</div>
					<div v-for="phone in myPhones" :key="phone.id" class="my-phone-card"
						:class="{'returned': phone.status === 1}">
						<div class="mp-card-header">
							<span class="mp-code">编码: {{ phone.phoneCode || '未填写' }}</span>
							<span class="mp-status" :class="phone.status === 1 ? 'st-returned' : 'st-active'">
								{{ phone.status === 1 ? '已归还' : '在用' }}
							</span>
							<span class="mp-date">{{ phone.registeredAt }}</span>
						</div>
						<div class="mp-photos">
							<div v-if="phone.photoFront" class="mp-photo-item" @click="showPhonePhoto(phone, 'photoFront')">
								<img :src="phone.photoFront" alt="正面"><span class="mp-label">正面</span>
							</div>
							<div v-if="phone.photoBack" class="mp-photo-item" @click="showPhonePhoto(phone, 'photoBack')">
								<img :src="phone.photoBack" alt="背面"><span class="mp-label">背面</span>
							</div>
							<div v-if="phone.photoCorner1" class="mp-photo-item" @click="showPhonePhoto(phone, 'photoCorner1')">
								<img :src="phone.photoCorner1" alt="左上角"><span class="mp-label">左上</span>
							</div>
							<div v-if="phone.photoCorner2" class="mp-photo-item" @click="showPhonePhoto(phone, 'photoCorner2')">
								<img :src="phone.photoCorner2" alt="右上角"><span class="mp-label">右上</span>
							</div>
							<div v-if="phone.photoCorner3" class="mp-photo-item" @click="showPhonePhoto(phone, 'photoCorner3')">
								<img :src="phone.photoCorner3" alt="左下角"><span class="mp-label">左下</span>
							</div>
							<div v-if="phone.photoCorner4" class="mp-photo-item" @click="showPhonePhoto(phone, 'photoCorner4')">
								<img :src="phone.photoCorner4" alt="右下角"><span class="mp-label">右下</span>
							</div>
						</div>
						<div v-if="phone.remark" class="mp-remark">备注: {{ phone.remark }}</div>
						<div class="mp-actions" v-if="phone.status !== 1">
							<el-button size="small" type="warning" @click="returnPhone(phone.id)">归还手机</el-button>
						</div>
					</div>
				</div>
			</el-dialog>
		</el-container>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatGroupOrderSide from "./ChatGroupOrderSide.vue";
import ChatBuyerProfileSide from "./ChatBuyerProfileSide.vue";
import ChatKqReportDialog from "./ChatKqReportDialog.vue";
import ChatAttendanceDialog from "./ChatAttendanceDialog.vue";
import ChatMyAttDialog from "./ChatMyAttDialog.vue";
import ChatSalesWechatDialog from "./ChatSalesWechatDialog.vue";
import TelesalesDialog from "./TelesalesDialog.vue";
import ChatAssignBoard from "./ChatAssignBoard.vue";
import ChatJin10Dialog from "./ChatJin10Dialog.vue";
import ChatPostDialog from "./ChatPostDialog.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";
import ForwardDialog from "./ForwardDialog.vue";
import MergeMessageViewer from "./MergeMessageViewer.vue";
import ChatSearchPanel from "./ChatSearchPanel.vue";
import MealCalendar from "../meal/MealCalendar.vue";
import bizApi from "../../api/bizApi.js";
import dataCrypto from "@/api/dataCrypto.js";
import { favoriteMessage, unfavoriteMessage, listFavoriteIds, listFavorites } from "../../api/favoriteApi.js";
import Recorder from 'js-audio-recorder';


export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		ChatGroupOrderSide,
		ChatBuyerProfileSide,
		ChatKqReportDialog,
		ChatAttendanceDialog,
		ChatMyAttDialog,
		ChatSalesWechatDialog,
		TelesalesDialog,
		ChatAssignBoard,
		ChatJin10Dialog,
		ChatPostDialog,
		Emotion,
		ChatRecord,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin,
		ForwardDialog,
		MergeMessageViewer,
		ChatSearchPanel,
		MealCalendar
	},
	props: {
		conversation: {
			type: Object
		}
	},
	data() {
		return {
			userInfo: {},
			groupId: null,
			isReceipt: true,
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			showOrderSide: false, // 是否显示订单面板
			orderSideManualClosed: false, // 用户是否在本会话手动关闭了订单面板(手动关后不再自动打开)
			orderCtx: null, // 群订单面板上下文(是否绑定商户/角色/是否成员)
			kqCtx: null, // 客勤群上下文(是否客勤群/可否填报)
			gateTypingUser: null, // 接待会话: 当前正在回复该买家的其他人昵称(null=无人回复中)
			gateTypingTimer: null, // 接待会话: "正在回复"状态轮询定时器
			gateTypingLastBeat: 0, // 接待会话: 上次"我正在回复"心跳上报时间(节流10秒)
			showBuyerSide: false, // 买家情况面板开关(芝麻接待会话,实时画像)
			showQuickReply: false, // 快捷回复面板开关
			showFavorite: false, // 收藏面板开关
			favoriteLoading: false,
			favorites: [], // 收藏列表
			gateQuickReplies: [], // 快捷回复列表
			quickReplyInput: '', // 新增/修改快捷回复输入
			editingQuickReply: null, // 正在修改的快捷回复(null=新增模式)
			searchVisible: false, // 是否显示搜索面板
			kqDialogVisible: false, // 客情填报弹窗
			attDialogVisible: false, // 考勤看板弹窗
			myAttDialogVisible: false, // 我的考勤弹窗(业务员)
			jin10DialogVisible: false, // 金十数据弹窗(快讯/头条/日历)
			postDialogVisible: false, // 一键发帖弹窗(员工多平台发帖: 绑定/发布/数据/评论)
			myAttStatus: null, // 我的今日考勤状态(null无记录 0待确认 1正常 2请假 3半天假)
			myAttLoaded: false,
			salesWechatDialogVisible: false, // 收款配置弹窗(支付宝接单+接单微信)
			telesalesDialogVisible: false, // 电销记录弹窗(交叉电话销售)
			fanKeyword: '', // 上粉群识别关键词(后台配置)
			activeMessageLocalId: '', //选中消息
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发消息
			lastScrollTime: 0,
			quoteMessage: null, // 当前引用回复的消息
			pinnedList: [], // 当前会话的置顶消息列表
			pinExpanded: false, // 置顶栏是否展开
			favoriteIds: [], // 当前会话中被收藏的消息id列表
			selectMode: false, // 多选转发模式
			selectedLocalIds: [], // 多选选中的消息localId
			forwardVisible: false, // 转发目标选择弹窗
			forwardMode: 'each', // 'each' 逐条 | 'merge' 合并
			forwardCount: 1, // 待转发消息条数
			forwardMessages: [], // 待转发的源消息
			mergeViewerVisible: false, // 聊天记录查看器
			mergeViewerData: null, // 查看器数据 {title, records}
			myPhoneVisible: false, // 我的手机弹窗
			myPhones: [], // 我的手机列表
			myPhoneLoading: false,
			hasPhones: false, // 当前用户是否有手机记录(控制按钮显示)
			voiceMode: false, // 语音模式(按住说话)
			isRecording: false, // 是否正在录音
			recordCancelled: false, // 是否取消录音(上滑)
			recordDuration: 0, // 录音时长(秒)
			recorder: null, // 录音器实例
			recordTimer: null, // 录音计时器
			voiceStartY: 0 // 录音起始Y坐标(用于判断上滑取消)
		}
	},
	methods: {
		onClickChatBox() {
			// 关闭表情窗口
			this.$refs.emoBox.close();
		},
		onCall(type) {
			// 视频通话已下线: 历史视频通话记录的"重新呼叫"也按语音发起
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE ||
				type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('voice');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
		},
		async onImageBefore(file) {
			const url = URL.createObjectURL(file);
			const data = {
				originUrl: url,
				thumbUrl: url
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.IMAGE,
				receipt: this.isGroup
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			// 插入消息
			await this.insertMessage(localMessage)
			// 借助file对象保存
			file.message = message;
			file.localMessage = localMessage;
			file.conversation = this.conversation;
			// 更新图片尺寸
			const size = await this.getImageSize(file)
			data.width = size.width;
			data.height = size.height;
			localMessage.content = JSON.stringify(data)
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
			this.scrollToBottom();
		},
		async onImageSuccess(data, file) {
			const message = file.message;
			message.content = JSON.stringify(data);
			await this.processSendMessage(file.conversation, message, file.localMessage);
		},
		async onImageFail(e, file) {
			const localMessage = file.localMessage;
			localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
		},
		async onFileBefore(file) {
			// 视频文件：改走视频消息（抽首帧做封面，发 VIDEO 类型，可缩略图预览+内联播放）
			if (file.type && file.type.startsWith('video/')) {
				file._isVideo = true;
				// 异步准备（抽帧+建本地消息+上传封面），上传完成后在 onFileSuccess 中 await
				file._videoReady = this.prepareVideoMessage(file);
				return;
			}
			const url = URL.createObjectURL(file);
			const data = {
				name: file.name,
				size: file.size,
				url: url
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.FILE,
				receipt: this.isGroup
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			// 插入消息
			await this.insertMessage(localMessage)
			// 借助file对象保存
			file.message = message;
			file.localMessage = localMessage;
			file.conversation = this.conversation;
		},
		async prepareVideoMessage(file) {
			// 抽取首帧封面 + 宽高/时长；失败则降级为无封面（仍可播放）
			const info = await this.getVideoInfo(file).catch(() => null);
			const localUrl = URL.createObjectURL(file);
			const data = {
				name: file.name,
				size: file.size,
				url: localUrl,
				thumbUrl: info ? info.thumbUrl : '',
				width: info ? info.width : 0,
				height: info ? info.height : 0,
				duration: info ? info.duration : 0
			};
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.VIDEO,
				receipt: this.isGroup
			};
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			const localMessage = this.buildLocalMessage(message);
			await this.insertMessage(localMessage);
			this.scrollToBottom();
			file.message = message;
			file.localMessage = localMessage;
			file.conversation = this.conversation;
			file._videoInfo = info;
			// 上传封面到图片服务，拿到服务器缩略图地址（失败不阻断，仅无封面）
			let thumbUrl = '';
			try {
				if (info && info.posterBlob) {
					const posterForm = new FormData();
					posterForm.append('file', info.posterBlob, 'poster.jpg');
					const imgData = await this.$http.post('/image/upload?isPermanent=false&thumbSize=300', posterForm, {
						headers: { 'Content-Type': 'multipart/form-data' }
					});
					thumbUrl = imgData.thumbUrl || imgData.originUrl || '';
				}
			} catch (e) { /* 封面上传失败则无封面 */ }
			file._thumbUrl = thumbUrl;
		},
		async onFileSuccess(url, file) {
			if (file._isVideo) {
				// 等待抽帧/封面准备完成，再组装最终视频消息
				await file._videoReady;
				const info = file._videoInfo || {};
				const data = {
					name: file.name,
					size: file.size,
					url: url,
					thumbUrl: file._thumbUrl || '',
					width: info.width || 0,
					height: info.height || 0,
					duration: info.duration || 0
				};
				const message = file.message;
				message.content = JSON.stringify(data);
				await this.processSendMessage(file.conversation, message, file.localMessage);
				return;
			}
			const data = {
				name: file.name,
				size: file.size,
				url: url
			}
			const message = file.message;
			message.content = JSON.stringify(data);
			await this.processSendMessage(file.conversation, message, file.localMessage);
		},
		async onFileFail(e, file) {
			if (file._isVideo) {
				// 等待本地消息建好再置为失败
				await file._videoReady;
			}
			const localMessage = file.localMessage;
			localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
		},
		onCloseSide() {
			this.showSide = false;
		},
		async onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			// 滚到顶部
			if (scrollTop < 30) {
				if (new Date().getTime() - this.lastScrollTime < 500) {
					return;
				}
				this.lastScrollTime = new Date().getTime();
				if (!this.chatStore.hasMoreLastMessage) {
					this.$message.success("没有更多消息了");
					return;
				}
				const hst = scrollElement.scrollHeight;
				await this.chatStore.loadLastPageMessage(this.conversation.key, 30);
				await this.$nextTick();
				// 恢复滚动条位置
				scrollElement.scrollTop = scrollElement.scrollHeight - hst;
				// 清除底部标志
				this.chatStore.setIsInBottom(false);
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				if (new Date().getTime() - this.lastScrollTime < 500) {
					return;
				}
				this.lastScrollTime = new Date().getTime();
				if (this.chatStore.hasMoreNextMessage) {
					// 向下翻页
					await this.chatStore.loadNextPageMessage(this.conversation.key, 30);
				}
				// 设置底部标志
				this.chatStore.setIsInBottom(!this.chatStore.hasMoreNextMessage);
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		toggleVoiceMode() {
			if (this.notAllowInputTip) {
				this.$message.warning(this.notAllowInputTip);
				return;
			}
			this.voiceMode = !this.voiceMode;
			if (!this.voiceMode) {
				this.$nextTick(() => {
					if (this.$refs.chatInputEditor) this.$refs.chatInputEditor.focus();
				});
			}
		},
		onVoiceStart(e) {
			e.preventDefault();
			this.isRecording = true;
			this.recordCancelled = false;
			this.recordDuration = 0;
			if (!this.recorder) {
				this.recorder = new Recorder();
			}
			this.recorder.start().then(() => {
				// started
			}).catch(() => {
				this.$message.error('无法访问麦克风，请检查浏览器权限');
				this.isRecording = false;
			});
			if (e.touches && e.touches[0]) {
				this.voiceStartY = e.touches[0].clientY;
			} else if (e.clientY !== undefined) {
				this.voiceStartY = e.clientY;
			}
			document.addEventListener('mousemove', this.onVoiceMove);
			document.addEventListener('mouseup', this.onVoiceEnd);
			document.addEventListener('touchmove', this.onVoiceMove, { passive: false });
			document.addEventListener('touchend', this.onVoiceEnd);
			this.recordTimer = setInterval(() => {
				this.recordDuration++;
			}, 1000);
		},
		onVoiceMove(e) {
			if (!this.isRecording) return;
			let clientY = 0;
			if (e.touches && e.touches[0]) {
				clientY = e.touches[0].clientY;
				e.preventDefault();
			} else if (e.clientY !== undefined) {
				clientY = e.clientY;
			}
			if (this.voiceStartY - clientY > 60) {
				this.recordCancelled = true;
			} else {
				this.recordCancelled = false;
			}
		},
		onVoiceEnd() {
			if (!this.isRecording) return;
			document.removeEventListener('mousemove', this.onVoiceMove);
			document.removeEventListener('mouseup', this.onVoiceEnd);
			document.removeEventListener('touchmove', this.onVoiceMove);
			document.removeEventListener('touchend', this.onVoiceEnd);
			clearInterval(this.recordTimer);
			this.recordTimer = null;
			let cancelled = this.recordCancelled;
			let duration = this.recordDuration;
			this.recorder.stop();
			this.isRecording = false;
			this.recordCancelled = false;
			if (cancelled) return;
			if (duration < 1) {
				this.$message.warning('录音时间太短');
				return;
			}
			let wav = this.recorder.getWAVBlob();
			let name = Date.now() + '.wav';
			let formData = new FormData();
			formData.append('file', wav, name);
			this.$http({
				url: '/file/upload',
				data: formData,
				method: 'post',
				headers: { 'Content-Type': 'multipart/form-data' }
			}).then((url) => {
				let data = { duration: duration, url: url };
				this.onSendRecord(data);
			}).catch(() => {
				this.$message.error('语音上传失败');
			});
		},
		showPrivateVideo(mode) {
			if (this.notAllowInputTip) {
				this.$message.warning(this.notAllowInputTip);
				return;
			}
			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 邀请成员发起通话
			let ids = [this.mine.id];
			let maxChannel = this.configStore.webrtc.maxChannel;
			this.$refs.rtcSel.open(maxChannel, ids, ids, []);
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true,
					isShareScreen: false
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		async onSendRecord(data) {
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.AUDIO,
				receipt: this.isGroup
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息	
			const localMessage = this.buildLocalMessage(message);
			await this.insertMessage(localMessage);
			await this.processSendMessage(this.conversation, message, localMessage);
			// 关闭录音窗口
			this.showRecord = false;
			// 保持输入框焦点
			this.$refs.chatInputEditor.focus();
		},
		fillTargetId(message, targetId) {
			if (this.isGroup) {
				message.groupId = targetId;
			} else {
				message.recvId = targetId;
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			// 接待会话防重复回复: 他人正在回复该买家时拦截发送
			if (this.gateTypingUser && this.isGateChat) {
				this.$message.warning(this.gateTypingUser + ' 正在回复该买家，请等待其回复完成');
				return;
			}
			this.resetEditor();
			this.readedMessage();
			let sendText = "";
			// 取出引用消息id后立即清除引用状态
			const quoteId = this.quoteMessage ? this.quoteMessage.id : null;
			this.quoteMessage = null;
			fullList.forEach(async msg => {
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds, quoteId);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}
			})
		},
		async sendImageMessage(file) {
			await this.onImageBefore(file);
			const formData = new FormData()
			formData.append('file', file)
			this.$http.post("/image/upload?isPermanent=false", formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((data) => {
				this.onImageSuccess(data, file);
			}).catch((res) => {
				this.onImageFail(res, file);
			})
			this.$nextTick(() => this.$refs.chatInputEditor.focus());
			this.scrollToBottom();
		},
		async sendTextMessage(sendText, atUserIds, quoteId) {
			if (!sendText.trim()) {
				return;
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: sendText,
				type: this.$enums.MESSAGE_TYPE.TEXT
			}
			// 引用回复的消息id
			if (quoteId) {
				message.quoteId = quoteId;
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			// 被@人员列表
			if (this.isGroup) {
				message.atUserIds = atUserIds;
				message.receipt = true;
			}
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			await this.insertMessage(localMessage);
			// 清空标志
			this.isReceipt = false;
			// 发送
			await this.processSendMessage(this.conversation, message, localMessage);
		},
		async sendFileMessage(file) {
			let check = this.$refs.fileUpload.beforeUpload(file);
			if (check) {
				this.$refs.fileUpload.onFileUpload({ file });
			}
		},
		getVideoInfo(file) {
			// 读取视频宽高/时长，并抽取首帧作为封面
			return new Promise((resolve, reject) => {
				const url = URL.createObjectURL(file);
				const video = document.createElement('video');
				video.preload = 'metadata';
				video.muted = true;
				video.playsInline = true;
				video.src = url;
				let captured = false;
				video.onloadedmetadata = () => {
					// 跳到约 0.1s 处抓帧，避免纯黑首帧
					const seekTo = Math.min(0.1, (video.duration || 1) / 2);
					try { video.currentTime = seekTo; } catch (e) { /* 某些浏览器需等待 */ }
				};
				video.onseeked = () => {
					if (captured) return;
					captured = true;
					try {
						const canvas = document.createElement('canvas');
						canvas.width = video.videoWidth || 320;
						canvas.height = video.videoHeight || 240;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
						const thumbUrl = canvas.toDataURL('image/jpeg', 0.8);
						canvas.toBlob((blob) => {
							URL.revokeObjectURL(url);
							resolve({
								width: video.videoWidth,
								height: video.videoHeight,
								duration: Math.round(video.duration || 0),
								thumbUrl,
								posterBlob: blob
							});
						}, 'image/jpeg', 0.8);
					} catch (e) {
						URL.revokeObjectURL(url);
						reject(e);
					}
				};
				video.onerror = () => {
					URL.revokeObjectURL(url);
					reject(new Error('无法读取视频'));
				};
			});
		},
		onCopyMessage(message) {
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(message.content).then(() => {
					this.$message.success('复制成功');
				}).catch(() => {
					this.$message.error('复制失败');
				});
			} else {
				this.$message.error('复制失败');
			}
		},
		async onResendMessage(message) {
			if (message.type != this.$enums.MESSAGE_TYPE.TEXT) {
				this.$message.error('该消息不支持自动重新发送，建议手动重新发送')
				return;
			}
			// 删除旧消息
			await this.chatStore.deleteMessage(this.conversation.key, message);
			// 重新推送
			const sendMessage = JSON.parse(JSON.stringify(message));
			sendMessage.localId = this.$nextSnowflakeId();
			const localMessage = this.buildLocalMessage(sendMessage);
			await this.insertMessage(localMessage);
			await this.processSendMessage(this.conversation, sendMessage, localMessage);
		},
		deleteMessage(message) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const convKey = this.conversation.key;
				if (message.id) {
					const data = {
						chatId: this.conversation.targetId,
						messageIds: [message.id]
					}
					await this.$http({
						url: `/message/${this.chatTypeText(this.conversation)}/deleteMessage`,
						method: 'delete',
						data: data
					});
				}
				this.chatStore.deleteMessage(convKey, message);
			});
		},
		recallMessage(message) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
			    const convKey = this.conversation.key;
				const url = `/message/${this.chatTypeText()}/recall/${message.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					m.selfSend = true;
					this.chatStore.recallMessage(convKey, m);
				})
			});
		},
		async locateMessage(message) {
			const localId = message.localId;
			const locateMessage = await this.$db.findMessageByLocalId(localId);
			if (!locateMessage || locateMessage.deleted || this.isRecall(locateMessage)) {
				this.$message.error('无法定位原消息');
				return;
			}
			await this.chatStore.locateToMessage(this.conversation.key, locateMessage)
			// 定位消息
			this.scrollToMessage(localId, 100, 0);
			// 选中消息
			this.activeMessageLocalId = localId;
			// 设置底部标记
			this.chatStore.setIsInBottom(!this.chatStore.hasMoreNextMessage);
		},
		scrollToMessage(id, delay, times) {
			setTimeout(() => {
				const messgaeItem = document.getElementById(id);
				if (messgaeItem) {
					messgaeItem.scrollIntoView({ behavior: 'smooth' });
				} else if (times < 3) {
					this.scrollToMessage(id, delay * 3, times + 1)
				} else {
					console.log("消息定位失败", delay)
				}
			}, delay)
		},
		async scrollToAtMessage() {
			if (this.conversation.lastAtMessageId < 0) {
				return;
			}
			const atMessage = await this.$db.findMessageById(this.conversation.key, this.conversation.lastAtMessageId);
			if (!atMessage) {
				this.$message.error('无法定位原消息');
				return;
			}
			await this.locateMessage(atMessage);
			await this.chatStore.resetAtMessage(this.conversation.key);
		},
		async readedMessage(force = false) {
			if ((this.conversation.unreadCount > 0 && this.conversation.maxMessageId > 0) || force) {
				const convKey = this.conversation.key;
				this.chatStore.resetUnreadCount(convKey);
				const tid = this.conversation.targetId;
				let url = "";
				if (this.isGroup) {
					url = `/message/group/readed?groupId=${tid}&messageId=${this.maxMessageId}`;
				} else {
					url = `/message/private/readed?friendId=${tid}&messageId=${this.maxMessageId}`;
				}
				await this.$http({
					url: url,
					method: 'put'
				})
			}
		},
		async loadReaded(fId) {
			const convKey = this.conversation.key;
			const messageId = await this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			})
			this.chatStore.readedMessage(convKey, messageId);
		},
		async loadGroup(groupId) {
			this.groupId = groupId;
			const group = await this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			})
			await this.chatStore.updateFromGroup(group);
			this.groupStore.updateGroup(group);
			this.groupStore.refreshMember(groupId);
		},
		// 加载群订单面板上下文(尽力而为，失败不影响聊天)
		loadOrderContext(groupId) {
			this.orderCtx = null;
			if (!groupId) {
				return;
			}
			bizApi.orderContext(groupId).then((ctx) => {
				// 避免快速切会话时旧结果覆盖
				if (this.isGroup && this.conversation.targetId == groupId) {
					this.orderCtx = ctx || null;
					// 绑定商户的群：若有进行中订单且未被手动关闭，则自动打开面板
					if (this.orderCtx && this.orderCtx.bound) {
						this.maybeAutoOpenOrderSide(groupId);
					}
				}
			}).catch(() => { });
		},
		// 加载客勤群上下文(尽力而为，失败不影响聊天)
		loadKqContext(groupId) {
			this.kqCtx = null;
			if (!groupId) {
				return;
			}
			bizApi.kqGroupCheck(groupId).then((ctx) => {
				// 避免快速切会话时旧结果覆盖
				if (this.isGroup && this.conversation.targetId == groupId) {
					this.kqCtx = (ctx && ctx.isKqGroup) ? ctx : null;
				}
			}).catch(() => { });
		},
		// ---------- 考勤 ----------
		openAttendance() {
			this.attDialogVisible = true;
		},
		// 我的今日考勤(业务员打卡按钮状态用)
		loadMyAttendance() {
			// 考勤开关关闭(商用版)不查——否则每次打开群聊后端拒绝报错,
			// 响应拦截器会全局弹"功能未开启: 考勤管理";打卡入口本就只在内部大群,
			// 其它群无需查询,一并收敛请求量(运营端开关开+内部大群时行为不变)
			if (!this.configStore.features.attendance || !this.isInternalGroup) {
				return;
			}
			if (!this.userStore || !this.userStore.isBizSales) {
				return;
			}
			bizApi.attMyToday().then((d) => {
				this.myAttLoaded = true;
				this.myAttStatus = d && d.status != null ? d.status : null;
			}).catch(() => { });
		},
		openKqDialog() {
			this.kqDialogVisible = true;
		},
		// ---------- 我的手机 ----------
		openMyPhones() {
			this.myPhoneVisible = true;
		},
		async checkMyPhones() {
			try {
				const data = await this.$http({ url: '/user/my-phones', method: 'get' });
				this.hasPhones = (data && data.length > 0);
			} catch (e) {
				this.hasPhones = false;
			}
		},
		async loadMyPhones() {
			this.myPhoneLoading = true;
			this.myPhones = [];
			try {
				const data = await this.$http({ url: '/user/my-phones', method: 'get' });
				this.myPhones = data || [];
				this.hasPhones = this.myPhones.length > 0;
			} catch (e) {
				this.$message.error('加载失败');
			} finally {
				this.myPhoneLoading = false;
			}
		},
		async returnPhone(id) {
			try {
				await this.$confirm('确认归还此手机？归还后将在记录中标记为已归还。', '提示', {
					confirmButtonText: '确认归还',
					cancelButtonText: '取消',
					type: 'warning'
				});
				await this.$http.post('/user/return-phone', { id });
				this.$message.success('归还成功');
				this.loadMyPhones();
			} catch (e) {
				if (e !== 'cancel' && e.message) {
					this.$message.error(e.message);
				}
			}
		},
		showPhonePhoto(phone, photoKey) {
			const photoKeys = ['photoFront', 'photoBack', 'photoCorner1', 'photoCorner2', 'photoCorner3', 'photoCorner4'];
			let urls = [];
			photoKeys.forEach(k => {
				if (phone[k]) urls.push(phone[k]);
			});
			if (urls.length === 0) return;
			let currentUrl = phone[photoKey] || urls[0];
			this.$eventBus.$emit('openFullImage', currentUrl, urls);
		},
		openWechatDialog() {
			this.salesWechatDialogVisible = true;
		},
		openTelesalesDialog() {
			this.telesalesDialogVisible = true;
		},
		// 拉取上粉群识别关键词(尽力而为,失败不显示入口)
		loadFanKeyword() {
			if (this.fanKeyword) {
				return;
			}
			bizApi.wechatFanKeyword().then((d) => {
				this.fanKeyword = (d && d.keyword) || '';
			}).catch(() => { });
		},
		// 有进行中订单(activeCount>0)且用户未手动关闭时自动打开订单面板
		maybeAutoOpenOrderSide(groupId) {
			if (!this.isGroup || this.orderSideManualClosed) {
				return;
			}
			if (!this.orderCtx || !this.orderCtx.bound) {
				return;
			}
			const gid = groupId || (this.conversation && this.conversation.targetId);
			if (!gid) {
				return;
			}
			bizApi.groupOrders(gid, 1, 1).then((d) => {
				// 防止快速切会话时旧结果误开
				if (!this.isGroup || this.conversation.targetId != gid || this.orderSideManualClosed) {
					return;
				}
				const activeCount = (d && d.activeCount) || 0;
				if (activeCount > 0) {
					this.showOrderSide = true;
					this.showSide = false;
				}
			}).catch(() => { });
		},
		toggleOrderSide() {
			this.showOrderSide = !this.showOrderSide;
			// 记录用户意图：手动关闭后本会话不再自动打开；手动打开则清除该标志
			this.orderSideManualClosed = !this.showOrderSide;
			if (this.showOrderSide) {
				this.showSide = false;
			}
		},
		// 子组件(订单面板内部关闭按钮)触发关闭：与手动关闭同效果
		onChildCloseOrderSide() {
			this.showOrderSide = false;
			this.orderSideManualClosed = true;
		},
		toggleGroupSide() {
			this.showSide = !this.showSide;
			if (this.showSide) {
				this.showOrderSide = false;
			}
		},
		async updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				const friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				await this.chatStore.updateFromFriend(friend);
				this.friendStore.updateFriend(friend);
			} else {
				await this.chatStore.updateFromUser(this.userInfo);
			}
		},
		async loadFriend(friendId) {
			// 获取好友信息
			const userInfo = await this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			});
			this.userInfo = userInfo;
			await this.updateFriendInfo();
			// 商城接待会话(芝麻买家影子账号)
			if (userInfo && userInfo.type === 99) {
				// 接待会话默认展开买家情况面板,实时数据一眼可见
				this.showBuyerSide = true;
				// 防重复回复: 开始轮询"谁正在回复该买家"
				this.startGateTypingWatch(friendId);
			} else {
				this.showBuyerSide = false;
				this.stopGateTypingWatch();
			}
		},
		toggleBuyerSide() {
			this.showBuyerSide = !this.showBuyerSide;
		},
		// 接待会话防重复回复: 轮询"谁正在回复该买家";后端 TTL 25秒,停止输入后自动解锁
		startGateTypingWatch(buyerUserId) {
			this.stopGateTypingWatch();
			const poll = async () => {
				if (!this.isGateChat) return;
				try {
					const data = await this.$http({
						url: `/biz/gate/chat/typing?buyerUserId=${buyerUserId}`,
						method: 'GET'
					});
					this.gateTypingUser = (data && data.typing) ? (data.nickName || '其他同事') : null;
				} catch (e) {
					this.gateTypingUser = null;
				}
			};
			poll();
			this.gateTypingTimer = setInterval(poll, 4000);
		},
		stopGateTypingWatch() {
			if (this.gateTypingTimer) {
				clearInterval(this.gateTypingTimer);
				this.gateTypingTimer = null;
			}
			this.gateTypingUser = null;
		},
		// 输入框键入 → 节流上报"我正在回复"(仅财务/管理员,后端 requireFinance 双保险)
		onGateTypingInput() {
			if (!this.isGateChat || !(this.userStore && this.userStore.isBizFinance)) return;
			const now = Date.now();
			if (now - this.gateTypingLastBeat < 10000) return;
			this.gateTypingLastBeat = now;
			this.$http({
				url: `/biz/gate/chat/typing/report?buyerUserId=${this.conversation.targetId}`,
				method: 'POST'
			}).catch(() => {});
		},
		toggleQuickReply() {
			this.showQuickReply = !this.showQuickReply;
			if (this.showQuickReply) {
				this.loadGateQuickReplies();
			}
		},
		toggleFavoritePanel() {
			this.showFavorite = !this.showFavorite;
			if (this.showFavorite) {
				this.showQuickReply = false;
				this.loadFavorites();
			}
		},
		async loadFavorites() {
			this.favoriteLoading = true;
			try {
				this.favorites = (await listFavorites()) || [];
			} catch (e) {
				this.favorites = [];
			} finally {
				this.favoriteLoading = false;
			}
		},
		favContentObj(f) {
			if (!f || f.messageType === 0 || !f.content) {
				return null;
			}
			try {
				return JSON.parse(f.content);
			} catch (e) {
				return null;
			}
		},
		favFileName(f) {
			const c = this.favContentObj(f);
			return (c && (c.name || c.fileName)) || '文件';
		},
		favPreviewText(f) {
			if (f.messageType === 0) {
				return f.content;
			}
			const c = this.favContentObj(f);
			if (f.messageType === 1) {
				return '[图片]';
			}
			if (f.messageType === 2) {
				return '[文件] ' + this.favFileName(f);
			}
			if (f.messageType === 3) {
				return '[语音] ' + (c && c.duration ? c.duration + '"' : '');
			}
			if (f.messageType === 4) {
				return '[视频]';
			}
			if (f.messageType === 5) {
				return '[聊天记录]';
			}
			return '[消息]';
		},
		pickFavorite(f) {
			if (f.messageType === 0) {
				if (this.notAllowInputTip) {
					this.$message.warning(this.notAllowInputTip);
					return;
				}
				// 文字: 填充到输入框供二次编辑,不直接发送
				this.showFavorite = false;
				this.$nextTick(() => {
					if (this.$refs.chatInputEditor) {
						this.$refs.chatInputEditor.insertText(f.content);
					}
				});
				return;
			}
			if (f.messageType === 1) {
				// 图片: 打开大图查看(与消息页图片交互一致)
				const c = this.favContentObj(f);
				const url = c ? (c.originUrl || c.url || c.thumbUrl) : null;
				if (url) {
					this.$eventBus.$emit("openFullImage", url, [url]);
				}
				return;
			}
			if (f.messageType === 2) {
				// 文件: 打开/下载
				const c = this.favContentObj(f);
				if (c && c.url) {
					window.open(c.url, '_blank');
				}
			}
			// 视频/语音在列表内直接播放,无需额外操作
		},
		copyFavorite(f) {
			if (f.messageType === 1) {
				// 图片复制为图片(与消息页右键复制同逻辑)
				this.copyFavoriteImage(f);
				return;
			}
			if (f.messageType !== 0) {
				this.$message.info('仅文字和图片支持复制');
				return;
			}
			const text = f.content || '';
			if (!text) {
				this.$message.warning('没有可复制的内容');
				return;
			}
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('已复制');
				}).catch(() => this.copyFallback(text));
			} else {
				this.copyFallback(text);
			}
		},
		async copyFavoriteImage(f) {
			try {
				const c = this.favContentObj(f);
				const url = c ? (c.originUrl || c.url || c.thumbUrl) : null;
				if (!url) {
					throw new Error('no url');
				}
				const resp = await fetch(url);
				if (!resp.ok) {
					throw new Error('fetch ' + resp.status);
				}
				let blob = await resp.blob();
				if (blob.type !== 'image/png') {
					blob = await new Promise((resolve, reject) => {
						const img = new Image();
						const objUrl = URL.createObjectURL(blob);
						img.onload = () => {
							const canvas = document.createElement('canvas');
							canvas.width = img.naturalWidth;
							canvas.height = img.naturalHeight;
							canvas.getContext('2d').drawImage(img, 0, 0);
							URL.revokeObjectURL(objUrl);
							canvas.toBlob(b => (b ? resolve(b) : reject(new Error('toBlob fail'))), 'image/png');
						};
						img.onerror = () => {
							URL.revokeObjectURL(objUrl);
							reject(new Error('img load fail'));
						};
						img.src = objUrl;
					});
				}
				await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
				this.$message.success('图片已复制，可直接粘贴');
			} catch (e) {
				console.warn('收藏图片复制失败:', e);
				this.$message.error('复制失败，请点击图片打开后右键复制');
			}
		},
		copyFallback(text) {
			const ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			document.execCommand('copy');
			document.body.removeChild(ta);
			this.$message.success('已复制');
		},
		async removeFavorite(f) {
			try {
				await unfavoriteMessage({ chatType: f.chatType, targetId: f.targetId, messageId: f.messageId });
				this.favorites = this.favorites.filter(x => x.id !== f.id);
				this.$message.success('已取消收藏');
			} catch (e) {
				this.$message.error('取消收藏失败');
			}
		},
		fmtFavoriteTime(t) {
			if (!t) {
				return '';
			}
			const d = new Date(t);
			const pad = n => (n < 10 ? '0' + n : '' + n);
			return (d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
		},
		async loadGateQuickReplies() {
			try {
				const data = await this.$http({
					url: '/biz/gate/quick-reply/list',
					method: 'GET'
				});
				this.gateQuickReplies = data || [];
			} catch (e) {
				this.gateQuickReplies = [];
			}
		},
		async addGateQuickReply() {
			const content = (this.quickReplyInput || '').trim();
			if (!content) {
				this.$message.warning('快捷回复内容不能为空');
				return;
			}
			await this.$http.post('/biz/gate/quick-reply/add', { content: content });
			this.quickReplyInput = '';
			this.editingQuickReply = null;
			this.loadGateQuickReplies();
		},
		async saveGateQuickReply() {
			if (!this.editingQuickReply) {
				return this.addGateQuickReply();
			}
			const content = (this.quickReplyInput || '').trim();
			if (!content) {
				this.$message.warning('快捷回复内容不能为空');
				return;
			}
			await this.$http.post('/biz/gate/quick-reply/update', { id: this.editingQuickReply.id, content: content });
			this.quickReplyInput = '';
			this.editingQuickReply = null;
			this.loadGateQuickReplies();
		},
		startEditQuickReply(r) {
			this.editingQuickReply = r;
			this.quickReplyInput = r.content;
		},
		cancelEditQuickReply() {
			this.editingQuickReply = null;
			this.quickReplyInput = '';
		},
		async deleteGateQuickReply(r) {
			await this.$http.post('/biz/gate/quick-reply/delete', { id: r.id });
			if (this.editingQuickReply && this.editingQuickReply.id === r.id) {
				this.cancelEditQuickReply();
			}
			this.loadGateQuickReplies();
		},
		pickGateQuickReply(r) {
			if (!this.isGateChatMine) {
				// 财务管理态不填充输入框: 发送入口仅meimei
				return;
			}
			// 填充到输入框供二次编辑,不直接发送
			this.showQuickReply = false;
			this.$nextTick(() => {
				if (this.$refs.chatInputEditor) {
					this.$refs.chatInputEditor.insertText(r.content);
				}
			});
		},
		showName(message) {
			if (!message) return "";
			if (this.isGroup) {
				const member = this.groupMemberMap.get(message.sendId);
				return member ? member.showNickName : "";
			} else if (message.sendId == this.mine.id) {
				return this.mine.nickName;
			} else {
				return this.conversation.showName;
			}
		},
		headImage(message) {
			if (this.isGroup) {
				const member = this.groupMemberMap.get(message.sendId);
				return member ? member.headImage : "";
			} else {
				return message.selfSend ? this.mine.headImageThumb : this.conversation.headImage
			}
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		async onScrollToBottom() {
			await this.chatStore.resetMessages(this.conversation.key);
			this.scrollToBottom();
		},
		async scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
				this.chatStore.setIsInBottom(true);
			});
		},
		async processSendMessage(conv, message, localMessage) {
			// 发送
			const m = await this.sendMessageRequest(conv, message).catch(async (e) => {
				// 更新本地消息
				localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				await this.chatStore.updateMessage(conv.key, localMessage);
			})
			if (m) {
				// 更新本地消息
				m.selfSend = true;
				m.convKey = conv.key;
				await this.chatStore.updateMessage(conv.key, m);
			}
		},
		sendMessageRequest(conv, message) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				const action = this.messageAction(conv)
				this.reqQueue.push({ action, message, resolve, reject });
				this.processReqQueue();
			})
		},
		async processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				// 传输层加密: 发送前加密content, DevTools中不可见明文
				const messageToSend = JSON.parse(JSON.stringify(reqData.message));
				if (messageToSend.content && dataCrypto.hasKey()) {
					messageToSend.content = await dataCrypto.enc(messageToSend.content);
				}
				this.$http({
					url: reqData.action,
					method: 'post',
					data: messageToSend
				}).then(async (res) => {
					// 传输层解密: 服务器返回的content是加密的
					if (res) await dataCrypto.decryptMessage(res);
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		buildLocalMessage(message) {
			const m = JSON.parse(JSON.stringify(message));
			m.convKey = this.conversation.key;
			m.seqNo = Math.max(1, this.conversation.maxSeqNo);
			m.sendId = this.mine.id;
			m.sendTime = new Date().getTime();
			m.status = this.$enums.MESSAGE_STATUS.SENDING;
			m.selfSend = true;
			if (this.isGroup) {
				m.readedCount = 0;
			}
			return m;
		},
		// ========== 消息转发 ==========
		// 单条转发（右键菜单）
		onForward(message) {
			this.forwardMessages = [message];
			this.forwardMode = 'each';
			this.forwardCount = 1;
			this.forwardVisible = true;
		},
		// 进入多选模式（右键菜单）
		enterSelectMode(message) {
			this.selectMode = true;
			this.selectedLocalIds = message ? [message.localId] : [];
		},
		exitSelectMode() {
			this.selectMode = false;
			this.selectedLocalIds = [];
		},
		onToggleSelect(message) {
			const idx = this.selectedLocalIds.indexOf(message.localId);
			if (idx >= 0) {
				this.selectedLocalIds.splice(idx, 1);
			} else {
				this.selectedLocalIds.push(message.localId);
			}
		},
		// 多选后转发（逐条/合并）
		onForwardSelected(mode) {
			if (!this.selectedLocalIds.length) {
				this.$message.warning('请先选择消息');
				return;
			}
			const list = this.messages.filter(m => this.selectedLocalIds.includes(m.localId))
				.slice().sort((a, b) => a.sendTime - b.sendTime);
			this.forwardMessages = list;
			this.forwardMode = mode;
			this.forwardCount = list.length;
			this.forwardVisible = true;
		},
		// 打开合并聊天记录查看器
		onOpenMerge(message) {
			let data;
			try {
				data = JSON.parse(message.content);
			} catch (e) {
				data = { title: '聊天记录', records: [] };
			}
			this.mergeViewerData = data;
			this.mergeViewerVisible = true;
		},
		// 确认转发到选定目标
		async doForward(targets) {
			this.forwardVisible = false;
			const mode = this.forwardMode;
			const sources = (this.forwardMessages || []).slice().sort((a, b) => a.sendTime - b.sendTime);
			if (!targets || !targets.length || !sources.length) {
				return;
			}
			try {
				for (const t of targets) {
					const conv = await this.ensureConv(t);
					if (mode === 'merge') {
						const records = sources.map(m => this.recordFromMessage(m));
						const content = JSON.stringify({ title: this.mergeTitle, records });
						await this.forwardOne(conv, this.$enums.MESSAGE_TYPE.MERGE, content);
					} else {
						for (const m of sources) {
							await this.forwardOne(conv, m.type, m.content);
						}
					}
				}
				this.$message.success('转发成功');
				this.exitSelectMode();
			} catch (e) {
				this.$message.error('转发失败');
			}
		},
		// 确保目标会话存在并返回
		async ensureConv(t) {
			await this.chatStore.openChat({
				type: t.type,
				targetId: t.targetId,
				showName: t.showName,
				headImage: t.headImage
			});
			const convKey = this.$db.buildConversationKey(t.type, t.targetId);
			return this.chatStore.conversationMap.get(convKey);
		},
		// 向指定会话发送一条转发消息
		async forwardOne(conv, type, content) {
			const message = {
				localId: this.$nextSnowflakeId(),
				content: content,
				type: type
			};
			if (conv.type == this.$enums.CONVERSATION_TYPE.GROUP) {
				message.groupId = conv.targetId;
				message.receipt = true;
			} else {
				message.recvId = conv.targetId;
			}
			const localMessage = this.buildLocalMessageFor(conv, message);
			await this.chatStore.insertMessage(conv.key, localMessage);
			await this.chatStore.moveTop(conv.key);
			await this.processSendMessage(conv, message, localMessage);
		},
		// 针对任意会话构造本地消息（target-aware）
		buildLocalMessageFor(conv, message) {
			const m = JSON.parse(JSON.stringify(message));
			m.convKey = conv.key;
			m.seqNo = Math.max(1, conv.maxSeqNo);
			m.sendId = this.mine.id;
			m.sendTime = new Date().getTime();
			m.status = this.$enums.MESSAGE_STATUS.SENDING;
			m.selfSend = true;
			if (conv.type == this.$enums.CONVERSATION_TYPE.GROUP) {
				m.readedCount = 0;
			}
			return m;
		},
		// 将消息转为合并记录项
		recordFromMessage(m) {
			return {
				sendId: m.sendId,
				sendNickName: m.selfSend ? this.mine.nickName : (m.sendNickName || this.showName(m)),
				sendTime: m.sendTime,
				type: m.type,
				content: m.content,
				headImage: this.headImage(m)
			};
		},
		getImageSize(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = function (event) {
					const img = new Image();
					img.onload = function () {
						resolve({ width: img.width, height: img.height });
					};
					img.onerror = function () {
						reject(new Error('无法加载图片'));
					};
					img.src = event.target.result;
				};
				reader.onerror = function () {
					reject(new Error('无法读取文件'));
				};
				reader.readAsDataURL(file);
			});
		},
		async insertMessage(message) {
			if (!this.chatStore.isInBottom) {
				await this.chatStore.resetMessages(this.conversation.key);
			}
			await this.chatStore.insertMessage(this.conversation.key, message)
			await this.chatStore.moveTop(this.conversation.key);
			this.scrollToBottom();
		},
		messageAction(conv) {
			return `/message/${this.chatTypeText(conv)}/send`;
		},
		chatTypeText(conv) {
			conv = conv ? conv : this.conversation;
			return conv.type == this.$enums.CONVERSATION_TYPE.PRIVATE ? "private" : "group";
		},
		isRecall(m) {
			return m.status == this.$enums.MESSAGE_STATUS.RECALL;
		},
		// 引用回复
		onQuote(message) {
			this.quoteMessage = message;
			this.$nextTick(() => this.$refs.chatInputEditor.focus());
		},
		cancelQuote() {
			this.quoteMessage = null;
		},
		async onLocateQuote(payload) {
			if (!payload || !payload.localId) {
				this.$message.error('无法定位原消息');
				return;
			}
			await this.locateMessage(payload);
		},
		// 编辑消息
		onEdit(message) {
			this.$prompt('编辑消息', '编辑', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputValue: message.content,
				inputValidator: (v) => (v && v.trim()) ? true : '内容不能为空'
			}).then(async ({ value }) => {
				const content = value.trim();
				if (content === message.content) {
					return;
				}
				// 传输层加密: 编辑消息时加密content
				let encryptedContent = content;
				if (dataCrypto.hasKey()) {
					encryptedContent = await dataCrypto.enc(content);
				}
				this.$http({
					url: `/message/${this.chatTypeText()}/edit`,
					method: 'put',
					data: { id: message.id, content: encryptedContent }
				}).then(() => {
					this.chatStore.editMessage(this.conversation.key, { id: message.id, content: content });
					this.$message.success('修改成功');
				});
			}).catch(() => { });
		},
		// 置顶消息
		onPin(message) {
			this.$http({
				url: '/message/pin',
				method: 'post',
				data: {
					chatType: this.conversation.type,
					targetId: this.conversation.targetId,
					messageId: message.id
				}
			}).then(() => {
				this.$message.success('已置顶');
				this.loadPinnedList();
			});
		},
		onUnpin(p) {
			this.$http({
				url: '/message/pin',
				method: 'delete',
				data: {
					chatType: this.conversation.type,
					targetId: this.conversation.targetId,
					messageId: p.messageId
				}
			}).then(() => {
				this.loadPinnedList();
			});
		},
		// 收藏/取消收藏消息
		onFavorite(message) {
			const isFavorited = this.favoriteIds.includes(message.id);
			const dto = {
				chatType: this.conversation.type,
				targetId: this.conversation.targetId,
				messageId: message.id
			};
			if (isFavorited) {
				unfavoriteMessage(dto).then(() => {
					const idx = this.favoriteIds.indexOf(message.id);
					if (idx >= 0) this.favoriteIds.splice(idx, 1);
					this.$message.success('已取消收藏');
				});
			} else {
				favoriteMessage(dto).then(() => {
					if (!this.favoriteIds.includes(message.id)) {
						this.favoriteIds.push(message.id);
					}
					this.$message.success('已收藏');
				});
			}
		},
		// 加载当前会话的收藏消息id列表
		async loadFavoriteIds() {
			if (!this.conversation) {
				this.favoriteIds = [];
				return;
			}
			try {
				const ids = await listFavoriteIds(this.conversation.type, this.conversation.targetId);
				this.favoriteIds = ids || [];
			} catch (e) {
				this.favoriteIds = [];
			}
		},
		async onLocatePin(p) {
			const m = await this.$db.findMessageById(this.conversation.key, p.messageId);
			if (!m) {
				this.$message.error('无法定位原消息');
				return;
			}
			await this.locateMessage(m);
		},
		onLocateSearchResult(item) {
			// 搜索结果定位：高亮对应消息
			const found = this.messages.find(m => m.id === item.id);
			if (found) {
				this.activeMessageLocalId = found.localId;
				this.$nextTick(() => {
					const el = document.getElementById(found.localId);
					if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
					setTimeout(() => { this.activeMessageLocalId = ''; }, 3000);
				});
			} else {
				this.$message.info('该消息不在当前加载范围内');
			}
		},
		async loadPinnedList() {
			if (!this.conversation) {
				this.pinnedList = [];
				return;
			}
			const list = await this.$http({
				url: `/message/pin/list?chatType=${this.conversation.type}&targetId=${this.conversation.targetId}`,
				method: 'get'
			});
			this.pinnedList = list || [];
			this.$nextTick(this.updatePinMarquee);
		},
		// 测量每条置顶内容宽度，超宽则启用跑马灯滚动
		updatePinMarquee() {
			if (!this.$el || !this.$el.querySelectorAll) {
				return;
			}
			const contents = this.$el.querySelectorAll('.pin-bar .pin-content');
			contents.forEach(el => {
				const text = el.querySelector('.pin-content-text');
				if (!text) {
					return;
				}
				const distance = text.scrollWidth - el.clientWidth;
				if (distance > 4) {
					el.classList.add('is-marquee');
					el.style.setProperty('--pin-scroll', distance + 'px');
					// 滚动速度约 40px/s，最短 4s
					const duration = Math.max(4, Math.round(distance / 40));
					el.style.setProperty('--pin-duration', duration + 's');
				} else {
					el.classList.remove('is-marquee');
					el.style.removeProperty('--pin-scroll');
					el.style.removeProperty('--pin-duration');
				}
			});
		},
		pinPreview(p) {
			return this.$msgUtil.previewContent({ type: p.messageType, content: p.content });
		},
		pinContentData(p) {
			try {
				return JSON.parse(p.content);
			} catch (e) {
				return {};
			}
		},
		pinIsImage(p) {
			return p.messageType == this.$enums.MESSAGE_TYPE.IMAGE;
		},
		pinIsVideo(p) {
			return p.messageType == this.$enums.MESSAGE_TYPE.VIDEO;
		},
		pinThumb(p) {
			const d = this.pinContentData(p);
			if (this.pinIsImage(p)) {
				return d.thumbUrl || d.originUrl || '';
			}
			if (this.pinIsVideo(p)) {
				return d.thumbUrl || '';
			}
			return '';
		},
		onOpenPinMedia(p) {
			const d = this.pinContentData(p);
			if (this.pinIsImage(p)) {
				this.$eventBus.$emit('openFullImage', d.originUrl || d.thumbUrl);
			} else if (this.pinIsVideo(p)) {
				this.$eventBus.$emit('openFullVideo', d.url);
			}
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		mergeTitle() {
			if (this.isGroup) {
				return '群聊的聊天记录';
			}
			return `${this.mine.nickName}和${this.conversation.showName}的聊天记录`;
		},
		quotePreview() {
			return this.quoteMessage ? this.$msgUtil.previewContent(this.quoteMessage) : '';
		},
		visiblePins() {
			return this.pinExpanded ? this.pinnedList : this.pinnedList.slice(0, 3);
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friend() {
			return this.friendStore.findFriend(this.userInfo.id) || {}
		},
		group() {
			return this.groupStore.findGroup(this.groupId) || {}
		},
		groupMembers() {
			return this.group.members || [];
		},
		groupMemberMap() {
			return new Map(this.groupMembers.map(m => [m.userId, m]));
		},
		title() {
			let title = this.conversation.showName;
			if (this.isGroup) {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			return title;
		},
		unreadCount() {
			return this.conversation.unreadCount;
		},
		messages() {
			return this.chatStore.messages;
		},
		memberSize() {
			return this.groupMembers.filter(m => !m.quit).length;
		},
		isPrivate() {
			return this.$enums.CONVERSATION_TYPE.PRIVATE == this.conversation.type
		},
		isGroup() {
			return this.$enums.CONVERSATION_TYPE.GROUP == this.conversation.type
		},
		// 是否科长账号(NB100002/nianchun, userId=4)的私聊: 是则工具栏显示「用餐统计」入口
		isMealBossChat() {
			return !this.isGroup && this.friend && this.friend.id === 4;
		},
		// 内部大群: 考勤功能入口开关(群名匹配,与后端既有约定一致)
		isInternalGroup() {
			return this.isGroup && this.group && (this.group.name || '').indexOf('内部大群') >= 0;
		},
		// 考勤管理入口: 内部大群 + 管理员/财务(商用版关闭考勤开关后隐藏)
		showAttEntry() {
			return this.isInternalGroup && this.configStore.features.attendance && this.userStore && this.userStore.isBizFinance;
		},
		// 打卡入口: 内部大群 + 业务员(管理员/财务不打卡;商用版关闭考勤开关后隐藏)
		showPunchEntry() {
			return this.isInternalGroup && this.configStore.features.attendance && this.userStore && this.userStore.isBizSales
				&& !(this.userStore && this.userStore.isBizFinance);
		},
		punchText() {
			if (this.myAttStatus === 0) return '待确认';
			if (this.myAttStatus != null) return '已打卡';
			return '考勤';
		},
		punchTip() {
			if (this.myAttStatus === 0) return '今日已打卡，等待管理员确认';
			if (this.myAttStatus != null) return '今日已有考勤记录';
			return '一键打卡，管理员确认后计正常';
		},
		// 上粉群(绑定商户的接单群,或群名含后台配置关键词): 显示接单微信配置入口
		isFanGroup() {
			if (!this.isGroup) {
				return false;
			}
			if (this.orderCtx && this.orderCtx.bound) {
				return true;
			}
			return !!this.fanKeyword && (this.group.name || '').includes(this.fanKeyword);
		},
		loading() {
			return this.chatStore.loading;
		},
		maxMessageId() {
			return this.conversation.maxMessageId;
		},
		notAllowInputTip() {
			if (this.isGroup) {
				if (this.group.dissolve) {
					return '群聊已解散';
				} else if (this.group.quit) {
					return '您已不在群聊中';
				} else if (this.group.isBanned) {
					return '群聊已被封禁' + (this.group.reason ? '，原因：' + this.group.reason : '');
				}
			} else if (this.userInfo.isBanned) {
				return '对方账号已被封禁' + (this.userInfo.reason ? '，原因：' + this.userInfo.reason : '');
			} else if (this.userInfo.type === 99 && !(this.userStore && this.userStore.isBizFinance)) {
				// 2026-08-18:接待会话放开给全部财务/管理员回复;业务员(订单分配后)可查看全部记录但不能回复
				if (this.userStore && this.userStore.bizRoles.includes(1)) {
					return '当前对话为商城接待会话，业务员可查看全部聊天记录，不能回复';
				}
				return '当前对话为商城接待会话，仅允许财务/管理员回复';
			}
			return '';
		},
		// 芝麻接待会话且当前用户可回复(财务/管理员): 快捷回复发送入口可见
		isGateChatMine() {
			return !this.isGroup && this.userInfo && this.userInfo.type === 99 && !this.notAllowInputTip;
		},
		// 芝麻接待买家私聊(type=99): 快捷回复管理入口的会话前提
		isGateChat() {
			return !this.isGroup && this.userInfo && this.userInfo.type === 99;
		},
		// 财务/管理员可在接待会话管理快捷回复(增/改/删),也可点选发送(2026-08-18 起全部财务/管理员可回复)
		canManageQuickReply() {
			return this.isGateChat && this.userStore && this.userStore.isBizFinance;
		}
	},
	watch: {
		conversation: {
			async handler(newConv, oldConv) {
				if (!oldConv || newConv.key != oldConv.key) {
					this.userInfo = {}
					this.groupId = null;
					this.stopGateTypingWatch();
					this.showBuyerSide = false;
					this.showQuickReply = false;
					this.showFavorite = false;
					this.editingQuickReply = null;
					if (this.isGroup) {
						this.loadGroup(this.conversation.targetId);
						this.loadOrderContext(this.conversation.targetId);
						this.loadKqContext(this.conversation.targetId);
						this.loadMyAttendance();
						this.checkMyPhones();
					} else {
						this.loadFriend(this.conversation.targetId);
						// 加载已读状态
						this.loadReaded(this.conversation.targetId)
						// 私聊清掉上一个群残留的订单/客勤上下文,避免分配看板等群专属组件泄漏到私聊
						this.orderCtx = null;
						this.kqCtx = null;
					}
					await this.chatStore.resetMessages(this.conversation.key)
					// 滚到底部
					this.scrollToBottom();
					this.showSide = false;
					this.showOrderSide = false;
					// 切会话重置“手动关闭”标志，使新会话可根据进行中订单自动打开
					this.orderSideManualClosed = false;
					// 消息已读
					this.readedMessage();
					// 重置输入框
					this.resetEditor();
					// 关闭表情窗口
					this.$refs.emoBox.close();
					// 复位回执消息
					this.isReceipt = false;
					// 清除引用状态并加载置顶列表
					this.quoteMessage = null;
				this.pinExpanded = false;
				this.loadPinnedList();
				this.loadFavoriteIds();
				}
			},
			immediate: true
		},
		loading: {
			async handler(newLoading, oldLoading) {
				if (newLoading) return;
				// 断线重连后，需要更新一下已读状态	
				if (this.isPrivate) {
					this.loadReaded(this.conversation.targetId);
				}
				// 如果用户所在的会话拉到了新的离线消息，需重置会话内的消息，否则新消息会不显示
				if (this.chatStore.hasMoreLastMessage) {
					await this.chatStore.resetMessages(this.conversation.key);
					this.scrollToBottom();
				}
			}
		},
		pinExpanded() {
			this.$nextTick(this.updatePinMarquee);
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
		this.loadFanKeyword();
		this.$eventBus.$on('newMessage', async (message) => {
			// 收到新消息,则滚动至底部
			if (this.$msgType.isNormal(message.type) || this.$msgType.isAction(message.type)) {
				// 新消息来时，如果用户本来就在底部不远位置，则直接拉到底部
				if (this.chatStore.isInBottom || message.selfSend) {
					this.scrollToBottom();
				}
				// 当前会话且在底部时，对方消息直接视为已读，无需未读角标
				if (!message.selfSend && this.chatStore.isInBottom) {
					this.readedMessage(true);
				}
			}
			// 订单分配/取消等通知到达当前已绑定商户的群时，尝试自动打开订单面板
			if (this.isGroup && message.groupId
				&& String(message.groupId) === String(this.conversation.targetId)) {
				this.maybeAutoOpenOrderSide(this.conversation.targetId);
			}
		});
		// 置顶变化时重新加载当前会话的置顶列表
		this.$eventBus.$on('pinChanged', (convKey) => {
			if (this.conversation && this.conversation.key == convKey) {
				this.loadPinnedList();
			}
		});
		// 收藏变化(多端同步): 刷新当前会话的收藏id列表
		this.$eventBus.$on('favoriteChanged', () => {
			if (this.conversation) {
				this.loadFavoriteIds();
			}
		});
		// 用户名片「@TA」：在当前群聊输入框末尾插入 @提及
		this.$eventBus.$on('insertAtUser', (user) => {
			if (!this.isGroup || !user || user.id == this.mine.id) {
				return;
			}
			this.$nextTick(() => {
				if (this.$refs.chatInputEditor) {
					this.$refs.chatInputEditor.insertMention({ id: user.id, name: user.name });
				}
			});
		});
		// 窗口尺寸变化时重新测量置顶跑马灯
		window.addEventListener('resize', this.updatePinMarquee);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updatePinMarquee);
		if (this.recordTimer) clearInterval(this.recordTimer);
		if (this.recorder) this.recorder.destroy();
		this.stopGateTypingWatch();
		document.removeEventListener('mousemove', this.onVoiceMove);
		document.removeEventListener('mouseup', this.onVoiceEnd);
		document.removeEventListener('touchmove', this.onVoiceMove);
		document.removeEventListener('touchend', this.onVoiceEnd);
	}
}
</script>

<style lang="scss" scoped>
.chat-box {
	position: relative;
	width: 100%;
	background: #fff;

	.el-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);

		.chat-title {
			flex: 1;
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		// 右侧图标组: flex自动排布, 避免旧版absolute硬编码right导致图标重叠
		.header-actions {
			display: flex;
			align-items: center;
			gap: 18px;
			flex-shrink: 0;
			margin-left: 12px;
		}

		.btn-side {
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}

		.btn-side-active {
			color: var(--im-color-primary);
		}
	}

	.content-box {
		position: relative;
		// 水平flex中聊天区需可收缩：不设 min-width:0 时其内容(工具栏/长文本)会撑破容器，
		// 订单/群信息面板弹出后总宽超过容器，页面失去宽度控制、右侧面板被挤出看不到。
		flex: 1;
		min-width: 0;
		overflow: hidden;

		.pin-bar {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			z-index: 98;
			display: flex;
			align-items: flex-start;
			padding: 6px 10px;
			background: #ffffff;
			border-bottom: var(--im-border);
			box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

			&.pin-bar-expanded {
				align-items: flex-start;
				box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
			}

			// 置顶标识：小号文字标签，比向上箭头更专业清晰
			.pin-bar-label {
				flex-shrink: 0;
				margin-right: 6px;
				padding: 0 5px;
				height: 18px;
				line-height: 18px;
				margin-top: 2px;
				font-size: 11px;
				color: var(--im-color-primary);
				background: var(--im-color-primary-light-8, rgba(64, 120, 255, 0.1));
				border-radius: 3px;
			}

			.pin-toggle {
				flex-shrink: 0;
				margin-left: 8px;
				color: var(--im-color-primary);
				font-size: 16px;
				line-height: 24px;
				cursor: pointer;
			}

			.pin-list {
				flex: 1;
				min-width: 0;

				.pin-item {
					font-size: var(--im-font-size-smaller);
					line-height: 22px;
					cursor: pointer;

					.pin-sender {
						color: var(--im-color-primary);
						margin-right: 4px;
						flex-shrink: 0;
						max-width: 80px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.pin-content {
						color: var(--im-text-color-light);
						overflow: hidden;
						white-space: nowrap;
						text-align: left;

						.pin-content-text {
							display: inline-block;
							white-space: nowrap;
							will-change: transform;
						}

						// 超宽内容：固定 0.8s 后开始跑马灯，往返滚动、末端短暂停顿
						&.is-marquee .pin-content-text {
							animation: pin-marquee var(--pin-duration, 8s) ease-in-out 0.8s infinite alternate;
						}
					}

					// 置顶的图片/视频：直接显示缩略图，点击可全屏查看/播放
					.pin-media {
						position: relative;
						display: inline-flex;
						align-items: center;
						flex-shrink: 0;
						cursor: pointer;

						.pin-thumb {
							width: 34px;
							height: 34px;
							border-radius: 4px;
							object-fit: cover;
							display: block;
							background: #000;
						}

						.pin-thumb-empty {
							display: flex;
							align-items: center;
							justify-content: center;
							color: #fff;
							font-size: 12px;
							background: #909399;
						}

						.pin-play {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							color: #fff;
							font-size: 18px;
							text-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
							pointer-events: none;
						}

						&:hover .pin-thumb {
							opacity: 0.85;
						}
					}

					.pin-remove {
						margin-left: 8px;
						color: var(--im-text-color-light);
						flex-shrink: 0;

						&:hover {
							color: var(--im-color-danger);
						}
					}

					&:hover .pin-content {
						color: var(--im-color-primary);
					}
				}

				// 收起：竖向堆叠，每条一行，最多 3 条
				&.pin-list-collapsed {
					display: block;

					.pin-item {
						display: flex;
						align-items: center;
						min-height: 26px;
						padding: 2px 0;

						& + .pin-item {
							border-top: 1px solid rgba(0, 0, 0, 0.05);
						}

						.pin-content {
							flex: 1;
							min-width: 0;
						}

						.pin-remove {
							margin-left: auto;
							padding-left: 8px;
						}
					}
				}

				// 展开：竖向列表，最多约 10 条高度，超出上下滚动
				&.pin-list-expanded {
					display: block;
					max-height: 300px;
					overflow-y: auto;

					.pin-item {
						display: flex;
						align-items: center;
						min-height: 34px;
						padding: 4px 0;

						& + .pin-item {
							border-top: 1px solid rgba(0, 0, 0, 0.05);
						}

						.pin-content {
							flex: 1;
							min-width: 0;
						}

						.pin-remove {
							margin-left: auto;
							padding-left: 8px;
						}
					}
				}
			}
		}

		// 置顶跑马灯：从 0 滚动到超宽距离，两端短暂停
		@keyframes pin-marquee {
			0% {
				transform: translateX(0);
			}
			80%, 100% {
				transform: translateX(calc(-1 * var(--pin-scroll, 0px)));
			}
		}

		.im-chat-main {
			padding: 0;
			background-color: #f4f5f6;

			.im-chat-box {
				>ul {
					padding: 0 20px;

					li {
						list-style-type: none;
					}
				}
			}
		}

		.locate-tip {
			text-align: center;
			position: absolute;
			right: 20px;
			bottom: 230px;
			color: var(--im-color-primary);
			font-size: var(--im-font-size);
			font-weight: 600;
			background: white;
			padding: 8px 16px;
			border-radius: 18px;
			cursor: pointer;
			z-index: 99;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			border: 1px solid rgba(0, 0, 0, 0.06);

			&:hover {
				transform: translateY(-1px);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
			}
		}

		.im-chat-select-bar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 16px;
			border-top: 1px solid var(--im-border-color-light, #f0f0f0);
			background: var(--im-background-active);

			.sel-count {
				font-size: 14px;
				color: var(--im-text-color);
			}

			.sel-actions {
				display: flex;
				align-items: center;
				gap: 8px;
			}
		}

		.im-chat-footer {
			position: relative;
			display: flex;
			flex-direction: column;
			padding: 0;

			.quote-tip {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 4px 10px;
				margin: 0 8px;
				background: var(--im-background-active);
				border-left: 3px solid var(--im-color-primary);
				border-radius: 4px;
				font-size: var(--im-font-size-smaller);
				color: var(--im-text-color-light);

				.quote-tip-content {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					flex: 1;
				}

				.quote-tip-close {
					cursor: pointer;
					margin-left: 8px;

					&:hover {
						color: var(--im-color-primary);
					}
				}
			}

			// 接待会话防重复回复提醒条: 黄条醒目
			.gate-typing-bar {
				display: flex;
				align-items: center;
				gap: 6px;
				padding: 6px 10px;
				background: #fdf6ec;
				border-bottom: 1px solid #f0e2c8;
				font-size: 13px;
				color: #e6a23c;
				font-weight: 600;
			}

			// 快捷回复面板: 悬浮在输入区上方
			.gate-qr-panel {
				position: absolute;
				left: 8px;
				bottom: calc(100% + 4px);
				width: 420px;
				max-width: calc(100% - 16px);
				background: #fff;
				border: 1px solid #e4e7ed;
				border-radius: 8px;
				box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
				z-index: 30;
				display: flex;
				flex-direction: column;

				.gate-qr-head {
					padding: 8px 12px 4px;
					font-size: 13px;
					font-weight: 600;
					color: #303133;

					.gate-qr-sub {
						margin-left: 8px;
						font-weight: 400;
						font-size: 12px;
						color: #909399;
					}
				}

				.gate-qr-list {
					max-height: 220px;
					overflow-y: auto;
					padding: 4px 8px;

					.gate-qr-empty {
						padding: 12px 4px;
						font-size: 12px;
						color: #909399;
						text-align: center;
					}

					.gate-qr-item {
						display: flex;
						align-items: center;
						gap: 8px;
						padding: 6px 8px;
						border-radius: 6px;
						cursor: pointer;
						font-size: 13px;
						color: #303133;

						&:hover {
							background: #f2f6fc;

							.gate-qr-del {
								visibility: visible;
							}
						}

						.gate-qr-text {
							flex: 1;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.gate-qr-del {
							visibility: hidden;
							color: #f56c6c;
							font-size: 14px;
						}
					}
				}

				.gate-qr-add {
					display: flex;
					align-items: center;
					gap: 6px;
					padding: 8px;
					border-top: 1px solid #ebeef5;
				}
			}

			.favorite-panel {
				position: absolute;
				left: 8px;
				bottom: calc(100% + 4px);
				width: 480px;
				max-width: calc(100% - 16px);
				background: #fff;
				border: 1px solid #e4e7ed;
				border-radius: 8px;
				box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
				z-index: 30;
				display: flex;
				flex-direction: column;

				.favorite-head {
					padding: 8px 12px 4px;
					font-size: 13px;
					font-weight: 600;
					color: #303133;
					display: flex;
					align-items: center;

					.favorite-sub {
						margin-left: 8px;
						font-weight: 400;
						font-size: 12px;
						color: #909399;
					}

					.favorite-close {
						margin-left: auto;
						cursor: pointer;
						color: #909399;

						&:hover {
							color: #303133;
						}
					}
				}

				.favorite-list {
					max-height: 300px;
					overflow-y: auto;
					padding: 4px 8px 8px;

					.favorite-empty {
						padding: 20px 4px;
						font-size: 12px;
						color: #909399;
						text-align: center;
					}

					.favorite-item {
						padding: 6px 8px;
						border-radius: 6px;
						font-size: 13px;
						color: #303133;

						&:hover {
							background: #f2f6fc;

							.fav-actions {
								visibility: visible;
							}
						}

						.fav-meta {
							font-size: 11px;
							color: #909399;
							margin-bottom: 2px;
						}

						.fav-body {
							cursor: pointer;

							.fav-img {
								max-width: 120px;
								max-height: 90px;
								border-radius: 4px;
								display: block;
							}

							.fav-video {
								max-width: 240px;
								max-height: 160px;
								border-radius: 4px;
								display: block;
								background: #000;
							}

							.fav-audio {
								height: 32px;
								max-width: 260px;
								display: block;
							}

							.fav-file {
								display: flex;
								align-items: center;
								gap: 4px;
								color: #409eff;

								.fav-file-name {
									max-width: 280px;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}

							.fav-text {
								white-space: pre-wrap;
								word-break: break-all;
							}

							.fav-plain {
								color: #909399;
							}
						}

						.fav-actions {
							visibility: hidden;
							margin-top: 4px;
							text-align: right;
						}
					}
				}
			}

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 44px;
				text-align: left;
				box-sizing: border-box;
				border-top: 2px solid #EBEEF5;
				padding: 6px 8px;
				align-items: center;
				background: var(--im-background-active);
				color: black;
				gap: 12px;
				opacity: 0.85;

				// 统一所有按钮的样式，参考新版本
				>div {
					font-size: 20px;
					cursor: pointer;
					width: 32px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					border-radius: 6px;
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

					&.chat-tool-active {
						color: var(--im-color-primary);
						background: var(--im-background-active-dark);
						transform: scale(1.02);
					}

					&:hover {
						color: var(--im-color-primary);
						background: var(--im-background-active);
						transform: translateY(-1px);
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					}
				}

				// 客情统计醒目入口(仅客勤群内可见)
				>div.kq-entry {
					width: auto;
					padding: 0 12px;
					gap: 5px;
					font-size: 14px;
					font-weight: 600;
					color: #fff;
					background: linear-gradient(135deg, #ff9800, #f56c6c);
					border-radius: 16px;
					box-shadow: 0 2px 8px rgba(245, 108, 108, 0.35);
					animation: kq-breath 2.2s ease-in-out infinite;

					i {
						font-size: 16px;
					}

					.kq-entry-text {
						font-size: 13px;
						line-height: 1;
						white-space: nowrap;
					}

					&:hover {
						color: #fff;
						background: linear-gradient(135deg, #f57c00, #e64242);
						transform: translateY(-1px);
						box-shadow: 0 4px 12px rgba(245, 108, 108, 0.5);
					}

					// 接单微信配置入口: 绿色区分于客情统计的橙色
					&.wechat-entry {
						background: linear-gradient(135deg, #34c759, #07c160);
						box-shadow: 0 2px 8px rgba(7, 193, 96, 0.35);

						&:hover {
							background: linear-gradient(135deg, #28a745, #06ad56);
							box-shadow: 0 4px 12px rgba(7, 193, 96, 0.5);
						}
					}

					// 考勤管理入口: 蓝色(管理员/财务)
					&.att-entry {
						background: linear-gradient(135deg, #5b8def, #4066d5);
						box-shadow: 0 2px 8px rgba(91, 141, 239, 0.35);
						animation: none;

						&:hover {
							background: linear-gradient(135deg, #4a7de0, #3355c4);
							box-shadow: 0 4px 12px rgba(91, 141, 239, 0.5);
						}
					}

					// 打卡入口: 青色(业务员)
					&.punch-entry {
						background: linear-gradient(135deg, #13c2c2, #0a9e9e);
						box-shadow: 0 2px 8px rgba(19, 194, 194, 0.35);
						animation: none;

						&:hover {
							background: linear-gradient(135deg, #0fb3b3, #088f8f);
							box-shadow: 0 4px 12px rgba(19, 194, 194, 0.5);
						}
					}

					// 一键发帖入口: 紫色(员工多平台发帖)
					&.post-entry {
						background: linear-gradient(135deg, #7b4fe0, #5b3bd6);
						box-shadow: 0 2px 8px rgba(123, 79, 224, 0.35);
						animation: none;

						&:hover {
							background: linear-gradient(135deg, #6a3bd6, #4a2fc0);
							box-shadow: 0 4px 12px rgba(123, 79, 224, 0.5);
						}
					}
				}
			}

			@keyframes kq-breath {
				0%, 100% { box-shadow: 0 2px 8px rgba(245, 108, 108, 0.35); }
				50% { box-shadow: 0 2px 14px rgba(245, 108, 108, 0.75); }
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: white !important;

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}

				.voice-hold-bar {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 100%;
					padding: 10px 16px;

					.voice-hold-btn {
						width: 100%;
						max-width: 300px;
						height: 40px;
						line-height: 40px;
						text-align: center;
						background: var(--im-background-active);
						border: 1px solid #ddd;
						border-radius: 8px;
						font-size: 14px;
						color: var(--im-text-color);
						cursor: pointer;
						user-select: none;
						transition: all 0.15s;

						&:hover {
							background: #e8e8e8;
						}

						&.recording {
							background: var(--im-color-primary);
							color: white;
							border-color: var(--im-color-primary);
						}

						&.will-cancel {
							background: #f56c6c;
							color: white;
							border-color: #f56c6c;
						}
					}
				}

				.voice-record-mask {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: rgba(0, 0, 0, 0.3);
					display: flex;
					align-items: center;
					justify-content: center;
					z-index: 100;

					.voice-record-box {
						display: flex;
						flex-direction: column;
						align-items: center;
						padding: 20px 30px;
						background: rgba(0, 0, 0, 0.7);
						border-radius: 12px;

						.voice-record-mic {
							width: 60px;
							height: 60px;
							border-radius: 50%;
							background: var(--im-color-primary);
							display: flex;
							align-items: center;
							justify-content: center;
							margin-bottom: 10px;

							i {
								font-size: 28px;
								color: white;
							}

							&.will-cancel {
								background: #f56c6c;
							}
						}

						.voice-record-tip {
							color: white;
							font-size: 14px;
							margin-bottom: 4px;
						}

						.voice-record-time {
							color: rgba(255, 255, 255, 0.7);
							font-size: 12px;
						}
					}
				}
			}

			.chat-editer-mask {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: #f8f8f8d0;
				font-size: var(--im-font-size-large);
				color: var(--im-text-color-light);
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 10px;
				border: 1px solid #ddd;
				z-index: 10;

				.icon {
					font-size: var(--im-font-size-larger);
					margin-right: 3px;
				}
			}
		}
	}

	.side-box {
		border-left: var(--im-border);
		// 侧栏固定宽度不参与收缩，收缩交给聊天区，保证面板始终完整可见
		flex-shrink: 0;
	}
}

</style>

<!-- 我的手机弹窗样式(非 scoped, 因为 dialog 在 body 上) -->
<style>
.my-phone-dialog .my-phone-card {
	border: 1px solid #e4e7ed;
	border-radius: 8px;
	padding: 14px;
	margin-bottom: 12px;
	transition: opacity .3s;
}
.my-phone-dialog .my-phone-card.returned {
	opacity: 0.55;
}
.my-phone-dialog .mp-card-header {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 10px;
}
.my-phone-dialog .mp-code {
	font-weight: 600;
	font-size: 14px;
}
.my-phone-dialog .mp-status {
	font-size: 12px;
	padding: 2px 8px;
	border-radius: 10px;
}
.my-phone-dialog .st-active {
	background: #67c23a;
	color: #fff;
}
.my-phone-dialog .st-returned {
	background: #909399;
	color: #fff;
}
.my-phone-dialog .mp-date {
	font-size: 12px;
	color: #999;
	margin-left: auto;
}
.my-phone-dialog .mp-photos {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
}
.my-phone-dialog .mp-photo-item {
	position: relative;
	aspect-ratio: 1;
	border-radius: 6px;
	overflow: hidden;
	cursor: pointer;
	border: 1px solid #e4e7ed;
}
.my-phone-dialog .mp-photo-item img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.my-phone-dialog .mp-photo-item:hover {
	border-color: #409eff;
}
.my-phone-dialog .mp-label {
	position: absolute;
	top: 3px;
	left: 3px;
	background: rgba(0,0,0,.6);
	color: #fff;
	font-size: 10px;
	padding: 1px 5px;
	border-radius: 3px;
}
.my-phone-dialog .mp-remark {
	font-size: 12px;
	color: #999;
	margin-top: 8px;
}
.my-phone-dialog .mp-actions {
	margin-top: 10px;
	text-align: right;
}
</style>